import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface MediaUploadDialogProps {
  file: File | null;
  isUploading?: boolean;
  onClose: () => void;
  onConfirm: (title: string, altText: string) => void;
}

export default function MediaUploadDialog({ file, isUploading = false, onClose, onConfirm }: MediaUploadDialogProps) {
  const [title, setTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setTitle("");
      setAltText("");
      setPreviewUrl(null);
      return;
    }
    setTitle(file.name);
    setAltText("");
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return (
    <Dialog open={!!file} onClose={isUploading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Media</DialogTitle>
      <DialogContent>
        {previewUrl && (
          <Box
            component="img"
            src={previewUrl}
            alt=""
            sx={{ width: "100%", maxHeight: 220, objectFit: "contain", borderRadius: 1, mb: 2, bgcolor: "#F5F5F5" }}
          />
        )}
        <TextField
          fullWidth
          required
          label={<>Title <span style={{ color: "red" }}>*</span></>}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
          disabled={isUploading}
        />
        <TextField
          fullWidth
          label="Alt Text"
          value={altText}
          onChange={(e) => setAltText(e.target.value)}
          margin="normal"
          disabled={isUploading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isUploading}>
          Cancel
        </Button>
        <Button onClick={() => onConfirm(title, altText)} variant="contained" disabled={isUploading || !title.trim()}>
          {isUploading ? "Uploading..." : "Upload"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
